import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import Select from "react-select";
import Alert from "@material-ui/lab/Alert";
import TableCell from "@material-ui/core/TableCell";
import LinearProgress from "@material-ui/core/LinearProgress";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    marginTop: 40,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
  checkbox: {
    width: "25px",
    height: "25px",
  },
  button: {
    margin: "5px",
  },
});

const UpdateTeamsEndpoint = (props) => {
  const classes = useStyles();
  const { dialPlans, voicePolicies } = props;
  const [updateType, setUpdateType] = useState("single");

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });
  };

  const clearAlert = () => {
    setAlertMessage({
      message: "",
      varient: "",
      active: false,
    });
  };

  const changeHandler = (value, name) => {
    clearAlert();
    if (value == "single" || value == "bulk") {
      setUpdateType(value);
      return;
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <Card className={classes.card}>
            {alertMessage.active && (
              <Alert
                severity={alertMessage.varient}
                onClose={() => clearAlert()}
              >
                {alertMessage.message}
              </Alert>
            )}
            <Typography
              sx={{ fontSize: 14 }}
              style={{ margin: "20px", fontSize: "1.5em" }}
              color="text.secondary"
              gutterBottom
            >
              Update Teams
            </Typography>
            <div class="mb-3 row">
              <div class="col-sm-1 col-form-label" />
              <div class="col-sm-9">
                <RadioGroup
                  row
                  name="row-radio-buttons-group"
                  onChange={(e) => changeHandler(e.target.value, e.target.name)}
                  defaultValue="single"
                >
                  <FormControlLabel
                    default
                    value="single"
                    control={<Radio color="primary" />}
                    label="Single"
                  />
                  <FormControlLabel
                    value="bulk"
                    control={<Radio color="primary" />}
                    label="Bulk"
                  />
                </RadioGroup>
              </div>
            </div>
            {updateType == "single" ? (
              <SingleUpdate
                sendAlert={sendAlert}
                clearAlert={clearAlert}
                dialPlans={dialPlans}
                voicePolicies={voicePolicies}
              />
            ) : (
              <BulkUpdate
                sendAlert={sendAlert}
                clearAlert={clearAlert}
                dialPlans={dialPlans}
                voicePolicies={voicePolicies}
              />
            )}
          </Card>
        </div>
      </div>
    </>
  );
};

const SingleUpdate = (props) => {
  const classes = useStyles();
  const { sendAlert, clearAlert, dialPlans, voicePolicies } = props;
  const [loading, setLoading] = useState(false);

  let dialPlanSelect = useRef(null);
  let voicePolicySelect = useRef(null);

  const [gminValue, setGMIN] = useState("");
  const [phoneNumberValue, setPhoneNumber] = useState("");
  const [dialPlanValue, setDialPlan] = useState("");
  const [voicePolicyValue, setVoicePolicy] = useState("");
  const [emailChecked, setEmailChecked] = useState(false);

  const [successFetch, setSuccessFetch] = useState(false);

  const clearAll = () => {
    setGMIN("");
    setPhoneNumber("");
    setDialPlan("");
    setVoicePolicy("");
    setEmailChecked(false);
    dialPlanSelect.select.clearValue();
    voicePolicySelect.select.clearValue();
  };

  const getDialPlans = () => {
    return dialPlans.map((plan) => {
      return { value: plan.value, label: plan.value };
    });
  };

  const getVoicePolicies = () => {
    return voicePolicies.map((policy) => {
      return { value: policy.value, label: policy.value };
    });
  };

  const singleSubmitHandler = (e) => {
    e.preventDefault();
    clearAlert();
    let dataForm = {
      gmin: gminValue,
      phoneNumber: phoneNumberValue,
      dialPlan: dialPlanValue,
      voicePolicy: voicePolicyValue,
      emailNotify: emailChecked,
    };

    let newDataForm = dataForm;

    Object.keys(newDataForm).map((key) =>
      newDataForm[key] === "" ? (newDataForm[key] = null) : newDataForm[key]
    );

    var alert = false;

    var errorMesssage = "Validation Error - ";

    if (newDataForm.gmin == null) {
      errorMesssage += "GMIN ";
      alert = true;
    }

    if (
      newDataForm.dialPlan == null &&
      newDataForm.voicePolicy == null &&
      newDataForm.phoneNumber == null
    ) {
      if (alert) errorMesssage += " & ";
      errorMesssage += "Either Dial Plan Or Voice Policy Or New Phone Number ";
      alert = true;
    }

    if (alert) {
      sendAlert((errorMesssage += "Required"), "warning");
      return;
    }

    setLoading(true);
    var success = false;
    var alreadyExists = true;

    fetchWithToken(`api/TeamsEndpoint/ByGMIN/${newDataForm.gmin}`)
      .then((res) => {
        if (!res.ok) {
          alreadyExists = false;
          return res.json();
        } else {
          fetchWithToken(`api/TeamsEndpoint/update/`, "PUT", newDataForm)
            .then((response) => {
              if (response.ok) {
                success = true;
                setSuccessFetch(true);
              }
              return response.json();
            })
            .then((data) => {
              setSuccessFetch(false);
              sendAlert(data.returnMessage, success ? "success" : "warning");
              setLoading(false);
            });
        }
      })
      .then((data) => {
        if (!alreadyExists) {
          sendAlert(data.returnMessage, "warning");
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    if (successFetch) clearAll();
  }, [successFetch]);

  const numberChangeHandler = (value) => {
    if (phoneNumberValue == "" && (value != "" || value != null))
      setEmailChecked(true);
    else if (value == "" || value == null) setEmailChecked(false);
    setPhoneNumber(value);
  };

  return (
    <>
      <div style={{ margin: "25px" }}>
        <form onSubmit={(e) => singleSubmitHandler(e)}>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <input
                type="text"
                style={{ fontSize: "0.875rem" }}
                class="form-control"
                name="gmin"
                placeholder="GMIN"
                maxlength="40"
                value={gminValue}
                onChange={(e) => {
                  clearAlert();
                  setGMIN(e.target.value);
                }}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <input
                type="number"
                style={{ fontSize: "0.875rem" }}
                class="form-control"
                name="phoneNumber"
                placeholder="Enter New Phone Number"
                maxlength="15"
                value={phoneNumberValue}
                onChange={(e) => {
                  clearAlert();
                  numberChangeHandler(e.target.value);
                }}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <Select
                ref={(ref) => {
                  dialPlanSelect = ref;
                }}
                name="dialPlan"
                placeholder="Select Dial Plan"
                isClearable={true}
                options={getDialPlans()}
                onChange={(selection) => {
                  clearAlert();
                  setDialPlan(
                    selection && selection.value ? selection.value : ""
                  );
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <Select
                ref={(ref) => {
                  voicePolicySelect = ref;
                }}
                name="voicePolicy"
                placeholder="Select Voice Policy"
                isClearable={true}
                options={getVoicePolicies()}
                onChange={(selection) => {
                  clearAlert();
                  setVoicePolicy(
                    selection && selection.value ? selection.value : ""
                  );
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-5" style={{ marginTop: "5px" }}>
              <h6>Notify Number Change By Email:</h6>
            </div>
            <div class="col-sm-5">
              <div>
                <input
                  type="checkbox"
                  name="emailNotify"
                  checked={emailChecked}
                  class="form-check-input"
                  className={classes.checkbox}
                  disabled={!phoneNumberValue}
                  onChange={(e) => {
                    clearAlert();
                    setEmailChecked(e.target.checked);
                  }}
                />
              </div>
            </div>
          </div>
          {loading && (
            <>
              <div style={{ margin: "25px" }}>
                <span style={{ display: "table", margin: "0 auto" }}>
                  Please Wait For Update to Finish
                </span>
                <LinearProgress />
              </div>
            </>
          )}
          <Button
            type="submit"
            variant="contained"
            className={classes.button}
            color="primary"
          >
            Update
          </Button>
        </form>
      </div>
    </>
  );
};

const BulkUpdate = (props) => {
  const classes = useStyles();

  let dialPlanSelect = useRef(null);
  let voicePolicySelect = useRef(null);

  const { sendAlert, clearAlert, dialPlans, voicePolicies } = props;
  const [isEmpty, setIsEmpty] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [bulkUpdateData, setBulkUpdateData] = useState({
    dialPlan: null,
    voicePolicy: null,
    userGMINs: [],
  });
  const [loading, setLoading] = useState(false);

  const [providedGMINs, setProvidedGMINs] = useState({ userGMINs: [] });
  const [dialPlanValue, setDialPlan] = useState(null);
  const [voicePolicyValue, setVoicePolicy] = useState(null);

  const [successFetch, setSuccessFetch] = useState(false);

  //Handlers
  const fileChangeHandler = (event) => {
    handleCancel();
    clearAlert();

    const file = event.target.files[0];
    event.target.value = "";
    setSelectedFile(file);
    setIsSelected(true);

    const reader = new FileReader();
    reader.onload = function (event) {
      const lines = event.target.result.split(/\r?\n/).filter(Boolean);
      const validNumbersSet = new Set();

      for (let line of lines) {
        const trimmed = line.trim();
        if (/^\d{9}$/.test(trimmed)) {
          validNumbersSet.add(Number(trimmed));
        }
      }

      const validNumbers = Array.from(validNumbersSet); // ensures uniqueness

      if (validNumbers.length === 0) {
        setIsEmpty(true);
        console.log("No valid 9-digit numbers found", "warning");
      } else {
        setIsEmpty(false);
        setProvidedGMINs({ userGMINs: validNumbers }); // validNumbers is number[]
      }
    };

    reader.readAsText(file);
  };
  const bulkSubmitHandler = (e) => {
    e.preventDefault();
    clearAlert();
    let bulkUpdateData = {
      userGMINs: providedGMINs.userGMINs,
      dialPlan: dialPlanValue,
      voicePolicy: voicePolicyValue,
    };

    let newBulkDataForm = bulkUpdateData;

    Object.keys(newBulkDataForm).map((key) =>
      newBulkDataForm[key] === ""
        ? (newBulkDataForm[key] = null)
        : newBulkDataForm[key]
    );

    var alert = false;

    var errorMesssage = "Validation Error - ";

    if (!isSelected) {
      errorMesssage += "No File Selected";
      alert = true;
    } else if (isEmpty) {
      errorMesssage += "No Content In File";
      alert = true;
    }

    if (
      newBulkDataForm.dialPlan == null &&
      newBulkDataForm.voicePolicy == null
    ) {
      if (isEmpty || !isSelected) errorMesssage += " & ";
      errorMesssage += "Either Dial Plan Or Voice Policy Required";
      alert = true;
    }

    if (alert) {
      sendAlert(errorMesssage, "warning");
      return;
    }

    let successfulResponse = false;
    setLoading(true);

    console.log("newBulkDataForm", newBulkDataForm);

    fetchWithToken(`api/TeamsEndpoint/bulkUpdate`, "PUT", newBulkDataForm)
      .then((res) => {
        if (res.ok) {
          successfulResponse = true;
          setSuccessFetch(true);
        }
        return res.json();
      })
      .then((data) => {
        setSuccessFetch(false);
        sendAlert(data.returnMessage, successfulResponse ? "success" : "error");
        setLoading(false);
      });

    handleCancel();
  };

  useEffect(() => {
    if (successFetch) clearAll();
  }, [successFetch]);

  const clearAll = () => {
    setProvidedGMINs({ userGMINs: [] });
    setDialPlan("");
    setVoicePolicy("");
    dialPlanSelect.select.clearValue();
    voicePolicySelect.select.clearValue();
  };

  const handleCancel = (event) => {
    clearAlert();
    setSelectedFile(null);
    setIsSelected(false);
    setProvidedGMINs({ userGMINs: [] });
    setBulkUpdateData({
      ...bulkUpdateData,
      userGMINs: [],
    });
  };

  const getDialPlans = () => {
    return dialPlans.map((plan) => {
      return { value: plan.value, label: plan.value };
    });
  };

  const getVoicePolicies = () => {
    return voicePolicies.map((policy) => {
      return { value: policy.value, label: policy.value };
    });
  };

  return (
    <>
      <div style={{ margin: "25px" }}>
        <form onSubmit={bulkSubmitHandler}>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <Select
                ref={(ref) => {
                  dialPlanSelect = ref;
                }}
                name="dialPlan"
                placeholder="Select Dial Plan"
                isClearable={true}
                options={getDialPlans()}
                onChange={(selection) => {
                  clearAlert();
                  setDialPlan(
                    selection && selection.value ? selection.value : ""
                  );
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-sm-12">
              <Select
                ref={(ref) => {
                  voicePolicySelect = ref;
                }}
                name="voicePolicy"
                placeholder="Select Voice Policy"
                isClearable={true}
                options={getVoicePolicies()}
                onChange={(selection) => {
                  clearAlert();
                  setVoicePolicy(
                    selection && selection.value ? selection.value : ""
                  );
                }}
                menuPortalTarget={document.querySelector("body")}
              />
            </div>
          </div>
          {loading && (
            <>
              <div style={{ margin: "25px" }}>
                <span style={{ display: "table", margin: "0 auto" }}>
                  Please Wait For Bulk Update to Finish
                </span>
                <LinearProgress />
              </div>
            </>
          )}
          <div class="mb-3 row">
            <TableCell class="col-sm-8">
              Upload File:{" "}
              {isSelected && (
                <>
                  {selectedFile.name} ({providedGMINs.userGMINs.length} GMINs)
                </>
              )}
              <br />
              <Button
                variant="contained"
                component="label"
                className={classes.button}
                color="primary"
              >
                Select File
                <input
                  type="file"
                  name="file"
                  accept=".txt"
                  onChange={fileChangeHandler}
                  hidden
                />
              </Button>
              <Button
                type="submit"
                variant="contained"
                className={classes.button}
                color="primary"
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={handleCancel}
                className={classes.button}
              >
                Cancel
              </Button>
            </TableCell>
          </div>
        </form>
      </div>
    </>
  );
};

export default UpdateTeamsEndpoint;
